var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"flex items-center justify-center text-blue-dark cursor-pointer hover:text-blue",on:{"click":function($event){return _vm.onClick()}}},[_c('i',{staticClass:"fas fa-search fa-lg"})])}
var staticRenderFns = []

export { render, staticRenderFns }